import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./../home/home.css";
import { webUrl, webUrlGarbhsanskar } from "../Utility/config";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import configData from "../../config.json";
import InteraktScript from "../../common/InteraktScript";
function Elementalcare() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [userid, setUserid] = useState();
  const [patientdata, setPatientdata] = useState([]);
  useEffect(() => {
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
  }, [userid]);
  const navigate = useNavigate();
  useEffect(() => {
    getsinglepatientdetail(userid);
  });
  const getsinglepatientdetail = async (id) => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/users/get_single_user`,
        {
          userId: id,
        }
      );

      if (response.data.success) {
        console.log("get single user successfully", response.data.user);

        setPatientdata(response.data.user);

        console.log("<><><><>", patientdata);
      } else {
        console.error(
          "Error adding medical registration details:",
          response.data.error
        );
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };
  const openapp = () => {
    if (patientdata.payment_status == true) {
      window.location.href = `${webUrl}`;
    }
    if (patientdata.payment_status == false) {
      window.location.href = `${webUrlGarbhsanskar}`;
    }
  };
  const openalert = () => {
    alert("Please Sign up");
  };
  return (
    <div className="new-home elementalcare-page">
      <Header userid={userid} />
      <section className="hero-banner elementalcare-hero">
        <div className="container py-5">
          <div className="row align-items-center min-vh-75">
            <div className="col-md-6 px-lg-5 order-2 order-md-1">
              <h1 className="display-4 fw-bold text-coral mb-4">
                The Discovery Experience: 7-day&apos;s of Premium Care, On Us
              </h1>
              <p className="lead text-muted mb-5 elementalcare-hero-copy">
                Experience the future of pregnancy care without spending a single rupee. Step
                inside our revolutionary pregnancy ecosystem and feel the profound difference of having a 24/7
                medical team, proactive AI tracking, and beautifully organized care right at your fingertips. Try
                the sanctuary first. Trust it later and forever.
              </p>
              {/* <Link to="/pricing" className="btn btn-cherish-lg">
                Start Your 7-Day Free Trial
              </Link> */}
               {userid === 0 || userid == null ? (
                 <Link
                  //  onClick={openalert}
                  to="/patient/Signup"
                   className="btn btn-cherish-lg px-5 shadow"
                 >
                   Start Your 7-Day Free Trial
                 </Link>
               ) : (
                 <button className="elementalcare-cta-shell">
                   <Link
                     onClick={openapp}
                     className="btn btn-cherish-lg px-5 shadow"
                   >
                     Start Your 7-Day Free Trial
                   </Link>
                 </button>
               )}
            </div>

            <div className="col-md-6 mt-4 mt-md-0 order-1 order-md-2">
              <img
                src="/7dayH.png"
                className="img-fluid floating-img elementalcare-hero-image"
                alt="Pregnancy care journey"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="elementalcare-feature-strip">
        <div className="container py-5">
          <div className="elementalcare-feature-grid">
            <article className="elementalcare-feature-card">
              <div className="elementalcare-feature-copy">
                <h2 className="elementalcare-feature-title">
                  Meet Nurture AI: Your 24/7 Smart Companion.
                </h2>
                <p className="elementalcare-feature-text">
                  Unlock access to our highly advanced, specially trained pregnancy AI. Whether you
                  need an instant analysis of complex lab reports, a breakdown of a medical prescription, or
                  immediate answers to late-night pregnancy questions, NurtureAI provides safe, personalized,
                  and deeply reassuring guidance around the clock.
                </p>
              </div>
              <div className="elementalcare-feature-media">
                <img
                  src="/7dayS21.png"
                  className="img-fluid"
                  alt="Starter package"
                />
              </div>
            </article>

            <article className="elementalcare-feature-card">
              <div className="elementalcare-feature-copy">
                <h2 className="elementalcare-feature-title">
                  Experience True Preventive Care.
                </h2>
                <p className="elementalcare-feature-text">
                   Test-drive our daily health tracking tool. Log your daily vitals on the app and watch
                   how our intelligent system and medical experts instantly analyze the data to flag risks. See
                   firsthand how proactive, daily monitoring brings absolute peace of mind compared to waiting
                   anxiously for a monthly clinic visit.
                </p>
              </div>
              <div className="elementalcare-feature-media">
                <img
                  src="/7dayS22.png"
                  className="img-fluid"
                  alt="24 x 7 availability"
                />
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="elementalcare-split-showcase">
        <div className="elementalcare-split-panel elementalcare-split-panel--tint">
          <div className="container py-5">
            <div className="elementalcare-split-row">
              <div className="elementalcare-split-copy">
                <h2 className="elementalcare-split-title">
                   Step Into Your Digital Sanctuary.
                </h2>
                <p className="elementalcare-split-text">
                   Get full, VIP access to the Myprega digital dashboard for 7 days. Experience the
                   sheer relief of having your pregnancy perfectly organized in one intuitive, tech-driven
                   ecosystem. No more cluttered files or fragmented information—just a seamless, end-to-end
                   command center built exclusively for the modern mother.
                </p>
              </div>
              <div className="elementalcare-split-media">
                <img
                  src="/7dayS31.png"
                  className="img-fluid"
                  alt="Every activity matters"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="elementalcare-split-panel elementalcare-split-panel--plain">
          <div className="container py-5">
            <div className="elementalcare-split-row">
              <div className="elementalcare-split-media">
                <img
                  src="/7dayS32.png"
                  className="img-fluid"
                  alt="Cutting-edge tech system"
                />
              </div>
              <div className="elementalcare-split-copy">
                <h2 className="elementalcare-split-title">
                   Elite Experts, Instantly Accessible.
                </h2>
                <p className="elementalcare-split-text">
                  Skip the endless waiting rooms. Enjoy 24/7 WhatsApp access to our certified
                  gynecologists to resolve your midnight doubts instantly. Plus, experience our clinical excellence
                  firsthand with a complimentary, unhurried 1-on-1 virtual consultation with a senior gynecologist,
                  right from your home.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="elementalcare-split-panel elementalcare-split-panel--tint">
          <div className="container py-5">
            <div className="elementalcare-split-row">
              <div className="elementalcare-split-copy">
                <h2 className="elementalcare-split-title">
                   Deepen Your Bond With Your Baby.
                </h2>
                <p className="elementalcare-split-text">
                   Immerse yourself in 7 days of our exclusive Garbhasanskar module. Experience
                   calming mind-body practices, beautiful bonding activities, and stress-melting audio rituals
                   scientifically designed to nurture your baby’s emotional development and give you moments of
                   profound tranquility during a busy workday.
                </p>
              </div>
              <div className="elementalcare-split-media">
                <img
                  src="/7dayS33.png"
                  className="img-fluid"
                  alt="Every activity matters"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="elementalcare-split-panel elementalcare-split-panel--plain">
          <div className="container py-5">
            <div className="elementalcare-split-row">
              <div className="elementalcare-split-media">
                <img
                  src="/7dayS34.png"
                  className="img-fluid"
                  alt="Cutting-edge tech system"
                />
              </div>
              <div className="elementalcare-split-copy">
                <h2 className="elementalcare-split-title">
                   Your Personalized Pregnancy Blueprint.
                </h2>
                <p className="elementalcare-split-text">
                   Cap off your trial with a dedicated 1-on-1 session with our expert pregnancy coach.
                  Together, you will map out a deeply personalized, step-by-step blueprint for the remaining
                  months of your journey. You’ll walk away with absolute clarity, zero anxiety, and a perfect plan
                  for a stress-free delivery.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="elementalcare-split-panel elementalcare-split-panel--tint">
          <div className="container py-5">
            <div className="elementalcare-split-row">
              <div className="elementalcare-split-copy">
                <h2 className="elementalcare-split-title">
                   Your Daily Dose of Confidence.
                </h2>
                <p className="elementalcare-split-text">
                  Replace late-night internet anxiety with medically backed clarity. For 7 days, receive
                  bite-sized, beautifully crafted daily education modules that explain exactly how your baby is
                  growing and what your body is experiencing. Step into each new day feeling completely
                  informed, prepared, and profoundly confident in your journey.
                </p>
              </div>
              <div className="elementalcare-split-media">
                <img
                  src="/7dayS35.png"
                  className="img-fluid"
                  alt="Every activity matters"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section 
             className="stats-section-wrapper"
             style={{ 
               backgroundImage: 'url("/NumberupB.png")', 
               backgroundSize: 'cover', 
               backgroundPosition: 'center',
               padding: '120px 0',
               textAlign: 'center',
               position: 'relative'
             }}
           >
             <img src="/Beyondtop.png" className="top-edge" alt="" />
             <div className="container">
               {/* Section Header */}
               <div className="stats-section-header">
                 <h3 className="stats-section-title">
                    ## Nothing to Lose. A Beautifully Orchestrated Pregnancy to Gain.
                 </h3>
                  <p className="journey-subtitle">
                    Stop managing your pregnancy alone, and let our elite experts and technology show
                    you how effortless this journey should feel. Step into your sanctuary today and experience the
                    Myprega difference firsthand—completely on us.
                  </p>
               </div>
               {userid === 0 || userid == null ? (
                 <Link
                   to="/patient/Signup"
                   className="btn btn-cherish-lg px-5 shadow"
                 >
                   Claim Your 7-Day Free Trial Now
                 </Link>
               ) : (
                 <button className="elementalcare-cta-shell">
                   <Link
                     onClick={openapp}
                     className="btn btn-cherish-lg px-5 shadow"
                   >
                     Claim Your 7-Day Free Trial Now
                   </Link>
                 </button>
               )}
             </div>
               <img src="/BeyondbottoM.png" className="bottom-edge" alt="" />
           </section>
      <Footer />
      <InteraktScript />
    </div>
  );
}

export default Elementalcare;
